import { render, staticRenderFns } from "./CarePlans.vue?vue&type=template&id=6b86291a&"
import script from "./CarePlans.vue?vue&type=script&lang=js&"
export * from "./CarePlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports